import {useEffect, useState} from "react";

import {isFetchBaseQueryError} from "@pg-mono/react-hook-forms-utils";

import {VERIFICATION_API_UNEXPECTED_ERROR} from "../constants/error_messages";

interface Params {
    errorData?: unknown;
}

export const useEmailVerificationApiError = (params: Params) => {
    const {errorData} = params;
    const statusesToIgnore: (number | string)[] = [429, 502, 503, 504];
    const [errorState, setErrorState] = useState<{isValid: boolean; message?: string}>(initialState);

    useEffect(() => {
        if (isFetchBaseQueryError(errorData)) {
            if (statusesToIgnore.includes(errorData.status)) {
                setErrorState(initialState);
                return;
            }

            const errorDataMessage =
                !!errorData?.data && typeof errorData.data === "object" && "message" in errorData.data && (errorData.data.message as string);
            const errorDirectMessage = "error" in errorData && errorData.error;

            setErrorState({isValid: false, message: errorDataMessage || errorDirectMessage || VERIFICATION_API_UNEXPECTED_ERROR});
            return;
        }
    }, [errorData]);

    return errorState;
};

const initialState = {isValid: true, message: undefined};
